import rolesConstants from '../constants/RolesConstants'
import { useSelector } from 'react-redux'

export const useIsMerchant = () => {
  return containRoles([
    rolesConstants.ROLE_MERCHANT,
    rolesConstants.ROLE_MERCHANTCOM,
    rolesConstants.ROLE_MERCHANTADMIN,
  ])
}

export const useIsMerchantCom = () => {
  return containRoles([rolesConstants.ROLE_MERCHANTCOM])
}

export const useIsMerchantAdmin = () => {
  return containRoles([rolesConstants.ROLE_MERCHANTADMIN])
}

export const useIsOperator = () => {
  return containRoles([rolesConstants.ROLE_OPERATOR])
}

export const useIsCommercial = () => {
  return containRoles([rolesConstants.ROLE_COMMERCIAL])
}

export const useIsAdmin = () => {
  return containRoles([rolesConstants.ROLE_ADMIN])
}

export const useIsViewer = () => {
  return containRoles([rolesConstants.ROLE_VIEWER])
}

export const useIsSupervisor = () => {
  return containRoles([rolesConstants.ROLE_SUPERVISOR])
}

export const useIsAgent = () => {
  return containRoles([rolesConstants.ROLE_OPERATOR, rolesConstants.ROLE_COMMERCIAL])
}

export const useIsAnySupervisor = () => {
  return containRoles([rolesConstants.ROLE_SUPERVISOR, rolesConstants.ROLE_VIEWER])
}

export const useIsAccountant = () => {
  return containRoles([rolesConstants.ROLE_ACCOUNTANT])
}

export const useIsLender = () => {
  return containRoles([rolesConstants.ROLE_LENDER])
}

export const useIsInternalAgent = () => {
  return containRoles([
    rolesConstants.ROLE_VIEWER,
    rolesConstants.ROLE_ACCOUNTANT,
    rolesConstants.ROLE_ADMIN,
    rolesConstants.ROLE_COMMERCIAL,
    rolesConstants.ROLE_OPERATOR,
  ])
}

export const useIsExternalRole = () => {
  return containRoles([
    rolesConstants.ROLE_MERCHANT,
    rolesConstants.ROLE_MERCHANTADMIN,
    rolesConstants.ROLE_MERCHANTCOM,
    rolesConstants.ROLE_SUPERVISOR,
  ])
}

export const useIsFinalCustomer = () => {
  return containRoles([rolesConstants.ROLE_FINALCUSTOMER])
}

export const containRoles = (rolesPermited) => {
  const roles = useSelector(({ login }) => login.roles)
  return roles.some((role) => rolesPermited.includes(role))
}
